import {
    ADD_FORM_TO_LIBRARY_EFFECT,
    FETCH_FORM_LIBRARY_LIST_EFFECT,
    APPLY_FORM_TO_EVENT_EFFECT,
    APPLY_FORM_WITH_FORM_ID_TO_EVENT_EFFECT,
    SEARCH_FORM,
    SAVE_FORM_LIBRARY_NAME_EFFECT,
    SAVE_FORM_AS_COPY_EFFECT,
    UPDATE_FORM_OWNERSHIP_EFFECT,
    GET_EVENT_THEME_COUNT_EFFECT,
} from '../constants/epicTypes';

// Effects
export const addFormToLibraryEffect = (meta) => ({
    type: ADD_FORM_TO_LIBRARY_EFFECT,
    meta,
});

export const fetchLibraryFormList = (meta) => ({
    type: FETCH_FORM_LIBRARY_LIST_EFFECT,
    meta,
});

export const applyFormToEventEffect = (meta) => ({
    type: APPLY_FORM_TO_EVENT_EFFECT,
    meta,
});

export const applyFormWithFormIdToEventEffect = (meta) => ({
    type: APPLY_FORM_WITH_FORM_ID_TO_EVENT_EFFECT,
    meta,
});

export const searchForm = (meta) => ({
    type: SEARCH_FORM,
    meta,
});

export const saveFormLibraryName = (meta) => ({
    type: SAVE_FORM_LIBRARY_NAME_EFFECT,
    meta,
});

export const saveFormAsCopyEffect = (meta) => ({
    type: SAVE_FORM_AS_COPY_EFFECT,
    meta,
});

export const updateFormOwnershipEffect = (meta) => ({
    type: UPDATE_FORM_OWNERSHIP_EFFECT,
    meta,
});

export const getEventThemeCount = (meta) => ({
    type: GET_EVENT_THEME_COUNT_EFFECT,
    meta,
});
